import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatAngularModule } from '../../shared/modules/mat-angular.module';
import { ComboChartComponent } from '../../shared/charts/combo-chart/combo-chart.component';

import { RouterModule } from '@angular/router';
import { OverviewResponse } from '../../services/education-overview.service';

@Component({
  selector: 'app-education-home',
  standalone: true,
  imports: [
    CommonModule,

    // Material Modules
    MatAngularModule,
    RouterModule,

    // Chart Modules
    NgxChartsModule,
    ComboChartComponent,
  ],
  templateUrl: './education-home.component.html',
  styleUrl: './education-home.component.scss'
})
export class EducationHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  // Static JSON data for combo chart
  // Overall university scores (Single Series)
  overallScoresData = [
    { name: 'MIT', value: 95 },
    { name: 'Stanford', value: 92 },
    { name: 'Oxford', value: 89 },
    { name: 'Harvard', value: 87 },
    { name: 'Cambridge', value: 85 },
    { name: 'Yale', value: 83 },
    { name: 'Princeton', value: 81 },
    { name: 'Columbia', value: 79 },
    { name: 'UC Berkeley', value: 77 },
    { name: 'UCLA', value: 75 },
    { name: 'University of Michigan', value: 73 },
    { name: 'University of Texas', value: 71 },
    { name: 'University of Washington', value: 69 },
    { name: 'University of Virginia', value: 67 },
    { name: 'University of North Carolina', value: 65 }
  ];

  // Per-model scores across universities (Multi-Series)
  multiSeriesData = [
    {
      name: 'ChatGPT',
      series: [
        { name: 'MIT', value: 98 },
        { name: 'Stanford', value: 95 },
        { name: 'Oxford', value: 90 },
        { name: 'Harvard', value: 88 },
        { name: 'Cambridge', value: 85 },
        { name: 'Yale', value: 83 },
        { name: 'Princeton', value: 81 },
        { name: 'Columbia', value: 79 },
        { name: 'UC Berkeley', value: 77 },
        { name: 'UCLA', value: 75 },
        { name: 'University of Michigan', value: 73 },
        { name: 'University of Texas', value: 71 },
        { name: 'University of Washington', value: 69 },
        { name: 'University of Virginia', value: 67 },
        { name: 'University of North Carolina', value: 65 }
      ]
    },
    {
      name: 'Gemini',
      series: [
        { name: 'MIT', value: 94 },
        { name: 'Stanford', value: 90 },
        { name: 'Oxford', value: 87 },
        { name: 'Harvard', value: 85 },
        { name: 'Cambridge', value: 83 },
        { name: 'Yale', value: 81 },
        { name: 'Princeton', value: 79 },
        { name: 'Columbia', value: 77 },
        { name: 'UC Berkeley', value: 75 },
        { name: 'UCLA', value: 73 },
        { name: 'University of Michigan', value: 71 },
        { name: 'University of Texas', value: 69 },
        { name: 'University of Washington', value: 67 },
        { name: 'University of Virginia', value: 65 },
        { name: 'University of North Carolina', value: 63 }
      ]
    },
    {
      name: 'Perplexity',
      series: [
        { name: 'MIT', value: 92 },
        { name: 'Stanford', value: 89 },
        { name: 'Oxford', value: 86 },
        { name: 'Harvard', value: 84 },
        { name: 'Cambridge', value: 82 },
        { name: 'Yale', value: 80 },
        { name: 'Princeton', value: 78 },
        { name: 'Columbia', value: 76 },
        { name: 'UC Berkeley', value: 74 },
        { name: 'UCLA', value: 72 },
        { name: 'University of Michigan', value: 70 },
        { name: 'University of Texas', value: 68 },
        { name: 'University of Washington', value: 66 },
        { name: 'University of Virginia', value: 64 },
        { name: 'University of North Carolina', value: 62 }
      ]
    },
    {
      name: 'Meta AI',
      series: [
        { name: 'MIT', value: 96 },
        { name: 'Stanford', value: 93 },
        { name: 'Oxford', value: 88 },
        { name: 'Harvard', value: 86 },
        { name: 'Cambridge', value: 84 },
        { name: 'Yale', value: 82 },
        { name: 'Princeton', value: 80 },
        { name: 'Columbia', value: 78 },
        { name: 'UC Berkeley', value: 76 },
        { name: 'UCLA', value: 74 },
        { name: 'University of Michigan', value: 72 },
        { name: 'University of Texas', value: 70 },
        { name: 'University of Washington', value: 68 },
        { name: 'University of Virginia', value: 66 },
        { name: 'University of North Carolina', value: 64 }
      ]
    }
  ];

  // Chart configuration
  chartView: [number, number] = [1000, 500];
  chartAnimations = true;

  // Overview data from API
  overviewData: OverviewResponse | null = null;


}
